var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "staricon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7396",
    fill: "rgba(255,255,255,0)",
    d: "M0 0h24v24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17705"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17699"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11044",
    d: "M12.001 1.889h-.043l-.055.012-.065.03-.062.049-.049.074-2.25 4.56-.1.179-.139.166-.148.148-.172.117-.179.1-.2.074-.21.043-5.035.733-.093.025-.062.043-.043.049-.037.05-.013.043-.006.037-.006.055.006.074.025.067.055.068 3.654 3.555.142.154.111.173.092.185.068.2.031.2.006.21-.018.21-.858 5.017-.006.092.018.08.037.056.038.043.03.024.037.025.056.025.062.006h.08l.086-.031 4.511-2.366.223-.093.235-.062.247-.018.247.018.235.062.223.093 4.511 2.366.086.031.08.006.062-.012.056-.025.036-.029.03-.024.038-.043.037-.056.018-.08-.008-.088-.857-5.015-.018-.21.006-.21.031-.2.074-.2.086-.185.111-.173.152-.157 3.643-3.555.057-.068.025-.067.006-.074v-.056l-.012-.037-.019-.043-.03-.05-.05-.049-.062-.043-.088-.025-5.035-.733-.21-.043-.2-.074-.179-.1-.17-.115-.148-.148-.136-.16-.1-.185-2.258-4.559-.049-.074-.062-.049-.062-.031-.055-.012Zm0-1.207.216.012.21.043.2.067.179.1.167.123.155.142.136.166.1.185 2.253 4.557.056.081.074.055.1.03 5.042.727.235.056.222.092.21.117.182.154.148.185.13.2.1.234.05.21.018.2-.006.21-.037.2-.062.2-.093.185-.117.179-.142.16-3.648 3.549-.055.088-.037.086.006.1.865 5.009.018.215-.006.21-.043.21-.062.191-.093.191-.117.172-.142.155-.167.142-.2.123-.223.092-.228.055-.228.018-.247-.018-.235-.055-.235-.1-4.512-2.374-.092-.025h-.1l-.092.025-4.505 2.366-.222.093-.241.067-.235.018-.241-.018-.228-.055-.222-.092-.21-.123-.167-.142-.142-.155-.117-.172-.093-.191-.062-.191-.043-.21-.006-.21.018-.215.87-5.009v-.1l-.03-.083-.055-.086-3.642-3.544-.148-.16-.117-.179-.093-.185-.062-.2-.037-.2-.006-.21.018-.2.05-.21.1-.234.13-.2.148-.185.186-.154.21-.117.222-.092.235-.056 5.042-.727.1-.03.074-.055.056-.081 2.249-4.566.1-.185.136-.166.155-.142.167-.123.179-.1.2-.067.2-.043Z",
    fill: "#02466a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17700"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11045",
    d: "m18.725 1.422.13.006.13.042.125.068.106.091.081.11.043.122.025.135-.006.126-.044.137-.068.116-.647.885-.106.1-.125.073-.13.049-.143.012-.118-.006-.125-.043-.112-.061-.106-.1-.081-.11-.05-.122-.018-.122.012-.141.038-.122.069-.129.647-.865.1-.1.112-.084.124-.049Z",
    fill: "#02466a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17701"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11046",
    d: "m5.311 1.422.134.018.122.049.108.079.092.105.638.873.062.122.036.128.006.128-.018.134-.044.123-.08.109-.1.092-.11.067-.115.037-.122.012-.14-.012-.135-.049-.115-.073-.1-.11-.635-.879-.061-.123-.043-.13-.006-.126.025-.135.042-.121.078-.11.1-.1.12-.066.134-.036Z",
    fill: "#02466a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17702"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11047",
    d: "M2.099 13.878h.143l.125.037.116.063.106.083.087.1.057.132.025.129v.14l-.032.122-.069.122-.081.1-.106.079-.137.055-1.047.342-.093.018-.1.006-.124-.012-.118-.037-.112-.061-.094-.086-.075-.1-.056-.122-.03-.134.006-.134.037-.122.056-.12.081-.1.112-.086.131-.054 1.053-.33Z",
    fill: "#02466a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17703"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11048",
    d: "m12 20.996.139.013.121.05.109.067.1.1.064.112.049.13.011.136v1.107l-.012.136-.049.137-.066.112-.1.093-.109.074-.121.044-.139.012-.139-.012-.121-.044-.109-.074-.1-.093-.06-.112-.049-.137-.012-.136v-1.107l.012-.136.049-.13.066-.112.1-.1.106-.068.121-.05Z",
    fill: "#02466a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17704"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11049",
    d: "m21.904 13.878.137.03 1.053.33.131.061.112.086.081.1.056.113.038.128.006.134-.03.134-.056.122-.075.1-.094.086-.112.061-.119.035-.124.012-.1-.006-.093-.018-1.046-.342-.137-.055-.106-.079-.081-.1-.07-.126-.031-.122v-.14l.025-.129.056-.128.087-.1.107-.087.117-.063.125-.037Z",
    fill: "#02466a",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaricon);
export default __webpack_public_path__ + "static/media/staricon.20d608a1ccff0615c356888c57f1196b.svg";
export { ForwardRef as ReactComponent };